import { render, staticRenderFns } from "./GoldEdit.vue?vue&type=template&id=b5405bd4&scoped=true&"
import script from "./GoldEdit.vue?vue&type=script&lang=js&"
export * from "./GoldEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5405bd4",
  null
  
)

export default component.exports